export function InformationBlock({ header, information }: { header: string; information: string[] }): JSX.Element {
  return (
    <>
      <h2>{header}</h2>
      {information.map((line) => (
        <p key={line}>{line}</p>
      ))}
    </>
  )
}
